import { Link } from "react-router-dom";
import SocialMediaLinks from "@/components/SocialMediaLinks";

const Footer = () => {
  const BRAND_LOGO = "/images/logos/brandborn.png";
  
  return (
    <footer className="bg-gray-900 text-white py-12 px-4">
      <div className="max-w-7xl mx-auto">
        {/* Service Locations Banner */}
        <div className="mb-8 p-4 bg-gray-800/50 rounded-xl text-center">
          <p className="text-sm text-gray-300 mb-2">
            <span className="font-semibold text-white">Serving Brands Across India</span>
          </p>
          <Link to="/service-locations" className="text-xs text-gray-400 hover:text-red-400 transition">
            Surat | Mumbai | Delhi | Pune | Gujarat | Punjab | Haryana | Noida | Gurgaon | Ludhiana | Chandigarh
          </Link>
        </div>

        <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src={BRAND_LOGO}
                alt="BrandBorn Logo" 
                className="h-10 w-10 rounded-lg object-contain"
              />
              <span className="text-xl font-bold">
                <span className="text-white">Brand</span>
                <span className="text-red-500">Born</span>
              </span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-2">
              India's #1 E-commerce Onboarding Agency with <span className="text-green-400 font-bold">98% Success Rate</span>.
            </p>
            <p className="text-gray-400 text-sm leading-relaxed mb-4">
              Your trusted partner for marketplace & quick commerce onboarding.
            </p>
            <div className="space-y-2 text-sm text-gray-400">
              <p>📧 business@brandborn.in</p>
              <p>📞 +91 94646 45491</p>
            </div>

            {/* Office Locations */}
            <div className="mt-4 space-y-2" data-testid="office-locations">
              <div className="flex items-start gap-2 text-sm">
                <span className="text-red-500 font-bold">📍</span>
                <div>
                  <p className="text-white font-bold text-xs uppercase tracking-wide">Head Office — Ludhiana</p>
                  <p className="text-gray-400 text-xs">Ludhiana, Punjab, India</p>
                </div>
              </div>
              <div className="flex items-start gap-2 text-sm">
                <span className="text-red-500 font-bold">📍</span>
                <div>
                  <p className="text-white font-bold text-xs uppercase tracking-wide">Branch Office — Patna</p>
                  <p className="text-gray-400 text-xs">Patna, Bihar, India</p>
                </div>
              </div>
            </div>
            
            {/* Social Media Links */}
            <div className="mt-6">
              <p className="text-sm text-gray-400 mb-3">Follow Us:</p>
              <SocialMediaLinks />
            </div>
          </div>
          
          <div>
            <h4 className="font-bold text-lg mb-4">Services</h4>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li><a href="#services" className="hover:text-red-400 transition">E-commerce Onboarding</a></li>
              <li><a href="#services" className="hover:text-red-400 transition">Quick Commerce</a></li>
              <li><a href="#services" className="hover:text-red-400 transition">Account Management</a></li>
              <li><Link to="/service-locations" className="hover:text-red-400 transition">Service Locations</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-bold text-lg mb-4">Platforms</h4>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li><Link to="/best-myntra-onboarding-agency-india" className="hover:text-red-400 transition">Myntra Onboarding</Link></li>
              <li><Link to="/nykaa-fashion-onboarding-agency" className="hover:text-red-400 transition">Nykaa Fashion Onboarding</Link></li>
              <li><Link to="/ajio-seller-registration-agency-india" className="hover:text-red-400 transition">Ajio Seller Registration</Link></li>
              <li><Link to="/meesho-seller-onboarding-agency" className="hover:text-red-400 transition">Meesho Seller Onboarding</Link></li>
              <li><Link to="/blinkit-onboarding-agency-india" className="hover:text-red-400 transition">Blinkit Onboarding</Link></li>
              <li><Link to="/swiggy-instamart-seller-onboarding" className="hover:text-red-400 transition">Swiggy Instamart Onboarding</Link></li>
              <li><Link to="/zepto-seller-onboarding-agency" className="hover:text-red-400 transition">Zepto Onboarding</Link></li>
              <li><Link to="/ecommerce-onboarding-agency-punjab" className="hover:text-red-400 transition">Onboarding Agency Punjab</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-bold text-lg mb-4">Company</h4>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li><Link to="/about" className="hover:text-red-400 transition">About Us</Link></li>
              <li><Link to="/economic-times" className="hover:text-red-400 transition">Featured in Economic Times</Link></li>
              <li><Link to="/media" className="hover:text-red-400 transition">BrandBorn in the Media</Link></li>
              <li><Link to="/certifications" className="hover:text-red-400 transition">Certifications</Link></li>
              <li><Link to="/ecomcatalog-ai" className="hover:text-red-400 transition">EcomCatalog.ai</Link></li>
              <li><Link to="/blog" className="hover:text-red-400 transition">Blog</Link></li>
              <li><a href="#contact" className="hover:text-red-400 transition">Contact Us</a></li>
              <li><a href="#faq" className="hover:text-red-400 transition">FAQ</a></li>
              <li><Link to="/refund-policy" className="hover:text-red-400 transition">Refund Policy</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-800 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © 2026 BrandBorn. All rights reserved. | E-commerce Onboarding Agency in India
          </p>
          <p className="text-gray-500 text-xs mt-2">
            Best ecommerce onboarding agency in Mumbai, Delhi, Surat, Ludhiana, Pune, Gujarat, Punjab, Haryana, Noida, Gurgaon, Chandigarh | Myntra, Nykaa, Ajio, Blinkit, Swiggy Instamart onboarding
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;